import React from 'react';

import {Grid} from '@material-ui/core';

import CounterCard from '../../@jumbo/components/Common/CounterCard';

type CountCardProps = {
    label: string,
    value: number | string,
    className: string
};

//
const CountCard = ({ label, value, className }: CountCardProps) => (
    <Grid item xs={12} sm={6} md={3}>
        {/* @ts-ignore js/ts conflicts */}
        <CounterCard
            className={className}
            number={value}
            numberProps={{
                color: 'black',
                fontSize: { xs: 20, xl: 22 },
                fontWeight: 'bold',
            }}
            label={label}
            labelProps={{
                color: 'black',
                fontSize: 12,
                fontWeight: 'normal',
            }}
        />
    </Grid>
);

export default CountCard;
